import React, { InputHTMLAttributes, ReactNode, useEffect, useRef } from 'react';
import Tooltip, { TooltipData } from '../tooltip/tooltip';
import { UseFormRegisterReturn } from 'react-hook-form';
import { hasValue } from 'utils/helper/type';

export type CheckboxSize = 'checkbox-xs' | 'checkbox-sm' | 'checkbox-md' | 'checkbox-lg';

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'size'> {
  color?: string;
  size?: CheckboxSize;
  label?: ReactNode;
  infoData?: TooltipData;
  register?: UseFormRegisterReturn;
  errors?: any;
  labelClassName?: string;
  indeterminate?: boolean;
}

const Checkbox = ({
  color = 'checkbox-primary',
  size = 'checkbox-sm',
  label,
  errors,
  register,
  name,
  infoData,
  className,
  labelClassName = '',
  onClick,
  onChange,
  onBlur,
  indeterminate,
  ...props
}: CheckboxProps) => {
  const ref = useRef(null);
  const error = errors?.[name];

  useEffect(() => {
    if (hasValue(indeterminate)) {
      ref.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  return (
    <>
      <label className='flex items-center gap-2'>
        <input
          ref={ref}
          type='checkbox'
          className={`checkbox ${color} ${size} ${className}`}
          {...register}
          {...props}
          onClick={(e) => onClick?.(e)}
          onChange={(e) => {
            register?.onChange?.(e);
            onChange?.(e);
          }}
          onBlur={(e) => {
            register?.onBlur?.(e);
            onBlur?.(e);
          }}
        />
        {label && <span className={`cursor-pointer text-sm text-text ${labelClassName}`}>{label}</span>}
        {infoData && (
          <Tooltip
            infoData={infoData}
            className='ml-2'
          />
        )}
      </label>
      <p className='text-xs text-error'>{error?.message}</p>
    </>
  );
};

export default Checkbox;
